<script setup lang="ts">
import { FormRow } from '@shared/ui/form-row'
import { RadioItem } from '@shared/ui/radio'

import { useTutorApplicationStore } from '../../model/store'
import { useReferralSource } from '../../model/additional-questions/referral-source.hooks'
import { referralSourceOptions } from '../../config/additional-questions'

defineOptions({
  name: 'ReferralSource',
})

const tutorApplicationStore = useTutorApplicationStore()

const {
  mode,
  label,
  setReferralSource,
} = useReferralSource()

</script>

<template>
  <FormRow
    :label="label"
    required
  >
    <RadioItem
      v-for="option in referralSourceOptions"
      :key="option.value"
      :mode="mode"
      :checked="tutorApplicationStore.form.referralSource === option.value"
      :label="option.label"
      @click="setReferralSource(option.value)"
    />
  </FormRow>
</template>
